export default __webpack_public_path__ + "static/media/francheville24.8a5b5033.jpg";